import type { FragmentType } from '@/gql/codegen';
import type { USER_ATTENDANCE_FRAGMENT } from '@/routes/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/-Page';
import type React from 'react';
import { CourseLessonsPage } from '../-Page';

export type CourseLessonsContainerProps = {
  embaUserAttendance: FragmentType<typeof USER_ATTENDANCE_FRAGMENT>;
};

export const CourseLessonsContainer = ({
  embaUserAttendance,
}: CourseLessonsContainerProps) => {
  return <CourseLessonsPage embaUserAttendance={embaUserAttendance} />;
};
